import React, { useState, useRef, useEffect } from 'react';
import styles from './index.module.scss';
import classNames from 'classnames';
import global from '../../index.module.scss';
import HeadContainer from '../../head-container';
import { getImageFromS3 } from '../../../imageService';

const RepresentativeOfSubcultureChallenge = ({
  setScreenNumber,
  setAfterResultScreen,
  challengeList,
  resultList,
  backgroundImage
}) => {
  const [challengeStep, setChallengeStep] = useState(0);
  const [selectQuestion, setSelectQuestion] = useState(challengeList[0]);
  const [challengeResult, setChallengeResult] = useState([]);
  const [isResultView, setIsResultView] = useState(false);
  const [isAfterResult, setIsAfterResult] = useState(false);
  const [isWelcomeScreen, setIsWelcomeScreen] = useState(true);
  const [result, setResult] = useState(null);

  // Додаємо стан для показу результату відповіді
  const [showAnswerResult, setShowAnswerResult] = useState(false);

  // Додаємо посилання на таймер
  const timerRef = useRef(null);

  // Прибираємо таймер при розмонтуванні компонента
  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  const handleSelect = (answer) => {
    const isExistAnswer = challengeResult.find(
      (item) => item.questionId === selectQuestion.id
    );
    if (isExistAnswer) {
      const updatedResultList = challengeResult.filter(
        (item) => item.questionId !== selectQuestion.id
      );
      setChallengeResult([
        ...updatedResultList,
        {
          questionId: selectQuestion.id,
          answerId: answer.id,
          isCorrect: answer?.isCorrect
        }
      ]);
    } else {
      setChallengeResult([
        ...challengeResult,
        {
          questionId: selectQuestion.id,
          answerId: answer.id,
          isCorrect: answer?.isCorrect
        }
      ]);
    }
  };

  const handleViewResult = () => {
    let correctAnswersCount = challengeResult?.filter(
      (item) => item?.isCorrect
    )?.length;
    const correctAnswerIndex =
      correctAnswersCount <= 2
        ? 0
        : correctAnswersCount >= 3 && correctAnswersCount <= 4
        ? 1
        : 2;
    setResult(resultList[correctAnswerIndex]);
    setIsResultView(true);
  };

  // Функція для обробки натискання кнопки "Далі"
  const handleNextClick = () => {
    // Показуємо результат відповіді (зелений або червоний фон)
    setShowAnswerResult(true);

    // Запускаємо таймер для переходу до наступного питання
    timerRef.current = setTimeout(() => {
      // Після паузи переходимо до наступного питання або результатів
      setShowAnswerResult(false);

      if (challengeList.length > challengeStep + 1) {
        setSelectQuestion(challengeList[challengeStep + 1]);
        setChallengeStep(challengeStep + 1);
      } else {
        handleViewResult();
      }
    }, 800); // Пауза 800 мс перед переходом
  };

  return (
    <div
      className={styles.imageSelectContainer}
      style={{ backgroundImage: backgroundImage }}
    >
      <div style={{ padding: '0 30px' }}>
        <HeadContainer setScreenNumber={setScreenNumber} />
      </div>
      {isWelcomeScreen && !isResultView && (
        <div className={styles.welcomeContainer}>
          <div className={styles.headContainer}>
            <img
              src={getImageFromS3(
                'images/percentage-of-your-bohemian-challenge/circle.png'
              )}
              alt="welcome-icon"
            />
            <p className={styles.title}>Знайди представника субкультури</p>
          </div>
          <p className={styles.description}>
            Сохо — це район абсолютно різних, але яскравих людей.<br></br>З усіх
            типажів та субкультур, спробуй вгадати, про кого з них йде мова.
          </p>
          <button onClick={() => setIsWelcomeScreen(false)}>Поїхали!</button>
        </div>
      )}
      {!isResultView && !result && !isWelcomeScreen && !isAfterResult && (
        <>
          <div className={styles.stepToolbar}>
            {challengeList.map((item, index) => (
              <div
                className={classNames(
                  styles.stepItem,
                  index === challengeStep && styles.activeStepItem
                )}
              />
            ))}
          </div>
          {selectQuestion && (
            <div className={styles.questionItem}>
              <span className={styles.titleQuestion}>
                {selectQuestion.title}
              </span>
              <div className={styles.imageList}>
                {selectQuestion.imageList.map((item) => {
                  const answer = challengeResult?.find(
                    (item) => item.questionId === selectQuestion.id
                  );

                  // Визначаємо, чи потрібно показувати результат відповіді
                  const showResult =
                    showAnswerResult && answer?.answerId === item.id;
                  // Визначаємо колір фону залежно від правильності відповіді
                  const resultBackgroundColor = item.isCorrect
                    ? 'rgba(0, 95, 11, 0.50)'
                    : 'rgba(209, 0, 0, 0.50)';

                  return (
                    <div
                      id={item.id}
                      onClick={() => handleSelect(item)}
                      className={classNames(
                        styles.imageContainer,
                        answer?.answerId === item.id &&
                          styles.selectedImageContainer
                      )}
                    >
                      <img
                        src={item.url}
                        alt={item.id}
                        className={styles.imageItem}
                      />
                      <div
                        className={styles.imageTitle}
                        style={{
                          backgroundColor: showResult
                            ? resultBackgroundColor
                            : undefined,
                          transition: 'background-color 0.3s ease'
                        }}
                      >
                        {item?.title}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
          <div className={styles.buttonContainer}>
            {challengeStep !== 0 && (
              <button
                className={global.reviewButton}
                onClick={() => {
                  setSelectQuestion(challengeList[challengeStep - 1]);
                  setChallengeStep(challengeStep - 1);
                }}
              >
                Назад
              </button>
            )}
            <button
              className={global.menuButton}
              onClick={handleNextClick}
              disabled={
                !challengeResult.find(
                  (item) => item.questionId === selectQuestion.id
                )
              }
            >
              Далі
            </button>
          </div>
        </>
      )}
      {isResultView && result && (
        <div className={styles.resultContainer}>
          <div>
            <h3 className={styles.resultHeading}>Результат</h3>
          </div>
          <img src={result?.image} alt="result" />
          <div className={styles.description}>
            <p className={styles.resultTitle}>{result.titleDescription}</p>
            <p className={styles.resultDescription}>{result.textDescription}</p>
          </div>
          <button
            className={global.reviewButton}
            onClick={() => {
              setIsAfterResult(true);
              setIsResultView(false);
              setIsWelcomeScreen(false);
            }}
          >
            Далі
          </button>
        </div>
      )}
      {isAfterResult && !isResultView && !isWelcomeScreen && (
        <div className={styles.afterResultContainer}>
          <img
            src={getImageFromS3(
              'images/representative-of-subculture-challenge/after-result.png'
            )}
            alt="after-result"
          />
          <p className={styles.title}>Було цікаво розгадувати?</p>
          <div className={styles.description}>
            Заглядай ще – у нас багато цікавих тестів та загадок.
          </div>
          <button className={global.menuButton} onClick={setAfterResultScreen}>
            Далі
          </button>
        </div>
      )}
    </div>
  );
};

export default RepresentativeOfSubcultureChallenge;
